'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCloudyNight = function IoIosCloudyNight(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.2 23.9c0.6 0 1.2-0.1 1.8-0.3-0.3 0.5-0.7 1.2-1.1 1.6-1.6 1.9-3.9 3.2-6.6 3.5h-0.2c0.3-0.8 0.6-1.7 0.6-2.5 0-1.7-0.7-3.4-1.9-4.6-1.1-1.1-2.6-1.8-4.2-1.8-0.4-1.3-1.2-2.3-2.2-3.2-0.8-0.6-1.6-1-2.5-1.3v-0.1c1.1-2.9 3.5-5.1 6.4-6.1 0.6-0.1 1.2-0.3 1.9-0.3-0.4 0.4-0.7 1-1 1.5-0.6 1.3-0.9 2.7-0.9 4.1 0 2.5 0.9 4.9 2.7 6.7s4.2 2.8 6.7 2.8h0.5z m-18.4-7.6c2.9 0 5.3 2.1 5.9 4.8h0.6c2.8 0 5.1 2.3 5.1 5.1s-2.3 5.1-5.1 5.1h-12.2c-2.2 0-4.1-1.8-4.1-4.1 0-2.1 1.6-4 3.7-4.2v-0.5c0-3.4 2.7-6.2 6.1-6.2z' })
        )
    );
};

exports.default = IoIosCloudyNight;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-cloudy-night.js
// module id = 2608
// module chunks = 168707334958949